import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { Button, Col, Form, Row, Table, Typography, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import { performGTMInvoiceChecks } from "api/gtmDashboard";
import { saveBrowserDataToFile } from "../../../utils";

const { Text, Title } = Typography;

const GTMInvoiceChecks = () => {
  const [file, setFile] = useState(null);
  const [flags, setFlags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.file);
    setError(null);
  };

  const handleSubmit = async () => {
    if (!file) {
      setError("Please select a CSV file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);
    setError(null);

    await performGTMInvoiceChecks({ invoiceCsv: formData })
      .then((r) => {
        setFlags(r);
      })
      .catch((r) => {
        setError(`Error processing invoice CSV, double check column names`);
      })
      .finally(() => setLoading(false));
  };

  const handleExport = () => {
    // Create a Blob containing the data
    const headerRow = "Kit ID,Date Received,Issue Types,Flagged Issues\n";
    const csvData = flags.map((obj) => {
      const shippingKitId = obj.shipping_kit_id;
      const dateRcvd = obj.date_received;
      const issueType = obj.type;
      const issueFlag = `${obj.flag.replace(/"/g, '""')}`; // Make Safe for CSV parsing
      const fullExportRow = `${shippingKitId},${dateRcvd},"${issueType}","${issueFlag}"`;

      return `${fullExportRow}\n`;
    });
    const fullData = headerRow.concat(csvData.join(""));

    // Construct a filename for the export
    const today = new Date();
    const exportName = `gtm_invoice_review_${today.toLocaleDateString()}_${today.toLocaleTimeString()}`;

    saveBrowserDataToFile(fullData, exportName, "text/csv");
  };

  return (
    <>
      <Title>
        Invoice Check{" "}
        <span style={{ fontSize: "16px" }}>This may take a minute...</span>
      </Title>
      <Form onFinish={handleSubmit}>
        <Form.Item>
          <Upload
            accept=".csv"
            maxCount={1}
            beforeUpload={() => false} // prevent auto-upload
            onChange={handleFileChange}
          >
            <Button icon={<UploadOutlined />}>Select CSV</Button>
          </Upload>
        </Form.Item>
        <Row>
          <Col>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                className="mr-3"
              >
                Submit
              </Button>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item>
              <Button onClick={handleExport}>Export Results</Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      {error && <Text style={{ color: "red" }}>{error}</Text>}
      <Table
        dataSource={flags}
        loading={loading}
        pagination={{ pageSize: 25 }}
        locale={{ emptyText: `No data yet` }}
        columns={[
          {
            title: "Kit ID",
            dataIndex: "shipping_kit_id",
            width: "150px",
          },
          {
            title: "Date Received",
            dataIndex: "date_received",
            width: "200px",
          },
          {
            title: "Issue Types",
            dataIndex: "type",
            width: "500px",
          },
          {
            title: "Flagged Issues",
            dataIndex: "html_flag",
            key: "html_flag",
            render: (html_flag) => {
              return <div dangerouslySetInnerHTML={{ __html: html_flag }} />;
            },
          },
        ]}
      ></Table>
    </>
  );
};

export default withRouter(GTMInvoiceChecks);
